import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import ReactGA from 'react-ga';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import lightGreen from '@material-ui/core/colors/lightGreen';


import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import deLocale from 'date-fns/locale/de';

import './App.css';

import AppHeader from './components/layout/AppHeader';
import AppFooter from './components/layout/AppFooter';
import Calculator from './components/calculator/Calculator';
import Infotext from './components/Infotext';



lightGreen.main = '#6c3';

const theme = createMuiTheme({
  palette: {
    primary: lightGreen,
  },
});


class App extends Component {
  render() {
    ReactGA.initialize([{
      trackingId: 'UA-2212393-52',
      debug: false,
      gaOptions: {
        anonymizeIp: true,
      },
    }],

    );
    ReactGA.pageview(window.location.pathname + window.location.search);

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
        <MuiThemeProvider theme={theme}>

          <Router>
            <div className="App">


              <AppHeader />

              <main>
                <Switch>
                  <Route path="/:curFrom/:curTo" component={Calculator} />
                  <Redirect from="/" to="/EUR/USD" />
                </Switch>

                <Infotext />
              </main>

              <AppFooter />

            </div>
          </Router>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js